<template>
    <div class="register-access-code-container login">
        <div class="login-form-wrapper">
		<branding-heading></branding-heading>
            <form @submit.prevent="login" class="" v-show="!submitted && !submittedCode" style="text-align:center">
                <p>Please choose one of the following options to create your user account.</p>
                <b-row>
                  <b-col sm="12" lg="6"  class="column__register-code">
                    <h2>Enter Access Code</h2>
                    <p>Enter the 6 character code below to create your user account within your organization.</p>
                    <b-form-group label=""
                    	:state="inputCodeStatus"
                    	:invalid-feedback="inputCodeMessage"
                    >
                    <PincodeInput
                      v-model="inputCode"
                      placeholder=""
                      :length="6"
                      class="mb-2"
                      @input="handlePinCodeInput"
                    />
                	</b-form-group>
                    <b-button :disabled="isButtonDisabled" variant="primary" type="button" @click="onSubmitCode">Submit Code</b-button>
                  </b-col>
                  <b-col sm="12" lg="6" class="column__register-organization pt-3 pt-lg-0 ">
                    <h2>Register My Organization</h2>
                    <p>Only <strong>ONE</strong> person should register for your organization.<br/>Once approved, this person will be able to add more users.</p>
                    <router-link class="btn btn-primary" to="/register-organization">Register New Organization</router-link>
                  </b-col>
                </b-row>
                <p style="text-align:center"></p>
                <p style="text-align:center"><b-link to="home">Back to Login</b-link></p>
                <p style="text-align:center">Contact <a href="mailto:PWDLaneClosures@winnipeg.ca">PWDLaneClosures@winnipeg.ca</a></p>
            </form>

            <div v-show="submitted && submittedCode" v-if="user != null">
              <h2>Please Confirm Your Registration</h2>
              <p>An email has been sent to <strong>{{user.email.value}}</strong>. <br/>Please click on the confirmation link within the email.</p>
              <p>Please note that we will still need to approve your registration before can log in.</p>

              <p><b-button :disabled="isButtonDisabled" @click="resendConfirmationEmail" class="mr-3 mb-2">Re-send Confirmation Email <b-spinner small label="Saving..." class="ml-2" v-if="saving" /></b-button> <b-button variant="light" @click="goBack" class="mb-2">Back to Login</b-button></p>
            </div>
            <b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
              <template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
              <ul>
                <li v-for="requiredField in modalRequiredFieldList" v-bind:key="'reqfield'+requiredField">{{$t(requiredField)}}</li>
              </ul>
              <template slot="footer">
                <b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
              </template>
            </b-modal>

            <b-modal centered v-model="showInvalidCodeModal" type="info" @confirm="showInvalidCodeModal = false">
              <template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
              <ul>
                <li>Invalid code was entered.  Please re-enter.</li>
              </ul>
              <template slot="footer">
                <b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalInvalidCodeClose" />
              </template>
            </b-modal>

<b-form @submit="onSubmit" @reset="onReset"  v-if="user != null" v-show="!submitted && submittedCode && submissionStatus != 'submission-success'">
	<h2>1. Create Your Login</h2>
	<b-row>
		<b-col lg="6">
			<b-form-group v-show="roleId == 'agency_user'"  label="Select your Organization or Group"
				:state="user.organizationId.status"
				:invalid-feedback="user.organizationId.invalidMessage"
			>
			<vue-select-grouped v-model="user.organizationId.value" :searchable="false" :canDelete="false"  :options="organizations" label="name" :reduce="name => name.id" @input="setOrganization">
				<template v-slot:option="optionGroup" :option="(typeof option === 'object')?option:{[name]: option, namePath:option.namePath, name:option.name, groupName:option.groupName}">
				</template>
				<template v-slot:option="option">
					<span :class="getLevelClassName(option.level)">{{ option.name }}</span>
				</template>
				<template v-slot:selected-option-container="option" :option="(typeof option === 'object')?option:{[name]: option, namePath:option.namePath, name:option.name}">
					<div class="vs__selected-options" v-html="getFlatTree(option.option)"></div>
				</template>
			</vue-select-grouped>
			</b-form-group>
			<b-form-group v-show="roleId != 'agency_user' && user.organizationId.value.parentId == null"  label="You will be an Agency Admin user for"
				:state="user.organizationId.status"
				:invalid-feedback="user.organizationId.invalidMessage"
			>
			<div class="" style="font-weight:bold;" v-html="getOrgName()"></div>
			</b-form-group>

			<b-form-group v-show="roleId != 'agency_user' && user.organizationId.value.parentId != null"  label="You will be an Agency Admin user for"
				:state="user.organizationId.status"
				:invalid-feedback="user.organizationId.invalidMessage"
			>
			<div class="" v-html="getOrgName()"></div>
			</b-form-group>



		</b-col>
	</b-row>
	<b-row>
	<b-col lg="6">

			<b-form-group label="Username"
				@click="focusUsernameField"
				:state="usernamePrefix.status"
				:invalid-feedback="usernamePrefix.invalidMessage"
				class="lc__username"
			>
				<p class="username-info">Your user name must end with <strong>{{ organizationSuffix }}</strong><br/>Please enter your user name.</p>
				<div @click="focusUsernameField" id="username-editable-content" class="form-control">
					<span id="username-prefix" class="editable" @keydown="handleLCKeypress" @focus="setFocusStyle" @blur="removeUsernameFocus" @input="setNewUsername" contenteditable="true" v-html="usernamePrefix.value"></span>
					<span id="username-postfix" class="non-editable">{{ organizationSuffix.trim() }}</span>
				</div>
			</b-form-group>

			<b-form-group label="Enter New Password"
				:state="user.password.status"
				:invalid-feedback="user.password.invalidMessage"
			>
			<b-input-group>
			<b-form-input
				v-model="user.password.value"
				id="password"
				:strength="passwordStrength"
				:type="passwordFieldType"
				@input="updatePasswordStrength"
				autocomplete="off"
			/>
			<b-input-group-append>
			<b-button variant="secondary" @click="switchPasswordVisibility()">show/hide</b-button>
			</b-input-group-append>
			</b-input-group>
			</b-form-group>


			<b-form-group label="First Name"
				:state="user.firstName.status"
				:invalid-feedback="user.firstName.invalidMessage"
			>
			<b-form-input placeholder="First Name" v-model="user.firstName.value"
				:state="user.firstName.status"
				@input="user.firstName.resetStatus()"
			></b-form-input>
			</b-form-group>


			<b-form-group label="Last Name"
				:state="user.lastName.status"
				:invalid-feedback="user.lastName.invalidMessage"
			>
			<b-form-input placeholder="Last Name" v-model="user.lastName.value"
				:state="user.lastName.status"
				@input="user.lastName.resetStatus()"
			></b-form-input>
			</b-form-group>

			<b-form-group label="Title"
				:state="user.title.status"
				:invalid-feedback="user.title.invalidMessage"
			>
			<b-form-input placeholder="Title" v-model="user.title.value"
				:state="user.title.status"
				@input="user.title.resetStatus()"
			></b-form-input>
			</b-form-group>

			<b-form-group label="Email Address"
				:state="user.email.status"
				:invalid-feedback="user.email.invalidMessage"
			>
			<b-form-input type="email" placeholder="Email Address" v-model="user.email.value"
				:state="user.email.status"
				@input="user.email.resetStatus()"
			></b-form-input>
			</b-form-group>
			<b-form-group v-if="false" label="Is Email Address Confirmed?"
				:state="user.isEmailConfirmed.status"
				:invalid-feedback="user.isEmailConfirmed.invalidMessage"
				id="fg-is-email-confirmed"
				class="fg-is-email-confirmed"
			>
				<b-form-radio-group
					id="rg-is-email-confirmed"
					v-model="user.isEmailConfirmed.value"
					:options="User.getEmailConfirmedOptions"
					@change="user.isEmailConfirmed.resetStatus()"
					:state="user.isEmailConfirmed.status"
				>
				</b-form-radio-group>
			</b-form-group>


			<b-form-group label="Primary Phone"
				:state="user.phone.status"
				:invalid-feedback="user.phone.invalidMessage"
			>
			<b-input id="registerPhone" type="tel" v-mask="'#-###-###-####'" masked="true" @focus="onPhoneFocus" @blur="onPhoneBlur" v-model="user.phone.value" placeholder="1-###-###-####"/>
			</b-form-group>


			<b-form-group label="Alternate Phone"
				:state="user.altPhone.status"
				:invalid-feedback="user.altPhone.invalidMessage"
			>
			<b-input id="registerAltPhone" type="tel" v-mask="'#-###-###-####'" masked="true" @focus="onAltPhoneFocus" @blur="onAltPhoneBlur" v-model="user.altPhone.value" placeholder="1-###-###-####"/>
			</b-form-group>
		</b-col>
		</b-row>
		<b-row>
			<b-col class="pt-3"><h2>2. Important / Recommended Notifications</h2></b-col>
		</b-row>
		<b-row>
			<b-col>
				<p>Winnipeg Lane Closures will send you notifications about the status of your lane closure requests.
				</p>
				<p><strong>Email notifications</strong>: Please check your trash or spam mailbox when email notifications are sent.</p>
				<p class="web-only"><strong>Push notifications</strong>:  Install the Winnipeg Lane Closures mobile app to have push notifications sent to your Android or IOS device.</p>
				<p class="app-only"><strong>Push notifications</strong>:  Turn ON have push notifications sent to your Android or IOS device.</p>
				<p v-if="!hideWeb"><strong>Web notifications</strong>: We recommend City of Winnipeg administrators turn Web notifications <strong>ON</strong> if you frequently use Winnipeg Lane Closures.</p>
				<p>Receive these notifications when you are the requester or a contact for a lane closure request.<br/>
				Activate the <strong>Include requests NOT assigned to me</strong> checkbox to ALSO receive notifications about  requests assigned to other people in your organization.</p>
			</b-col>
		</b-row>

		<b-row>
			<b-col>
			<div class="collapsible text-primary">
		<div class="collapse--content collapse show">
		<b-col class="mb-3">
			<user-notification-setting :setting="'lcr-new-message'" :hideWeb="hideWeb" :forceEmail="true" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
			<user-notification-setting :setting="'lcr-approved'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
			<user-notification-setting :setting="'lc-not-opened'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
			<user-notification-setting :setting="'new-contravention'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
		</b-col>
		</div>
		</div>
		</b-col>
		</b-row>


		<b-row>
			<b-col class="pt-3"><h2>3. Additional Notifications</h2>
				<p>Expand each of the sections below and choose your preferences.</p>
			</b-col>
		</b-row>

		<b-row>
			<b-col>
				<div :class="collapseLcrUpdateNotifications ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
					<template>
						<div class="collapsible-heading p-0">
							<div class="d-flex flex-nowrap bottom-border">
								<div class="collapsible-heading__value" @click="collapseLcrUpdateNotifications = !collapseLcrUpdateNotifications">
									Updates to Status or Details
								</div>

								<div class="collapsible-heading__toggle">
									<b-button href="#" variant="collapsible" :class="collapseLcrUpdateNotifications ? '' : ' collapsed'" :aria-expanded="collapseLcrUpdateNotifications ? 'true' : 'false'" aria-controls="collapseLcrUpdateNotifications" @click="collapseLcrUpdateNotifications = !collapseLcrUpdateNotifications">
										<span class="when-opened">
											<font-awesome-icon icon="chevron-down" />
										</span>
										<span class="when-closed">
											<font-awesome-icon icon="chevron-right" />
										</span>
									</b-button>
								</div>
							</div>
						</div>
						<b-collapse id="collapseLcrUpdateNotifications" :visible="collapseLcrUpdateNotifications" class="collapse--content">
							<b-col class="mb-3">
								<user-notification-setting :setting="'lcr-updated'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							<user-notification-setting :setting="'lcr-attachment'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>

								<user-notification-setting :setting="'lcr-denied'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								<user-notification-setting :setting="'lcr-completed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								<user-notification-setting :setting="'lcr-cancelled'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								<user-notification-setting :setting="'lcr-contact-added'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								<user-notification-setting :setting="'lcr-contact-removed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								<user-notification-setting :setting="'new-lcr'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
							</b-col>
						</b-collapse>
					</template>
				</div>
			</b-col>
		</b-row>

			<b-row>
				<b-col>
					<div :class="collapseReminders ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
						<template>
							<div class="collapsible-heading p-0">
								<div class="d-flex flex-nowrap bottom-border">
									<div class="collapsible-heading__value" @click="collapseReminders = !collapseReminders">
										Reminders
									</div>
									<div class="collapsible-heading__toggle">
										<b-button href="#" variant="collapsible" :class="collapseReminders ? '' : ' collapsed'" :aria-expanded="collapseReminders ? 'true' : 'false'" aria-controls="collapseReminders" @click="collapseReminders = !collapseReminders">
											<span class="when-opened">
												<font-awesome-icon icon="chevron-down" />
											</span>
											<span class="when-closed">
												<font-awesome-icon icon="chevron-right" />
											</span>
										</b-button>
									</div>
								</div>
							</div>
							<b-collapse id="collapseReminders" :visible="collapseReminders" class="collapse--content">
								<b-col class="mb-3 mt-3">
									Be reminded when you should report lanes closed at the start time and re-opened at the completion time.
								</b-col>
								<b-col class="mb-3">
								<user-notification-setting :setting="'lc-reminder-close'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								<user-notification-setting :setting="'lc-reminder-open'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								<user-notification-setting :setting="'r-reminder-place'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								<user-notification-setting :setting="'r-reminder-remove'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								</b-col>
							</b-collapse>
						</template>
					</div>
				</b-col>
			</b-row>


			<b-row>
				<b-col>
					<div :class="collapseAlerts ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
						<template>
							<div class="collapsible-heading p-0">
								<div class="d-flex flex-nowrap bottom-border">
									<div class="collapsible-heading__value" @click="collapseAlerts = !collapseAlerts">
										Warnings
									</div>
									<div class="collapsible-heading__toggle">
										<b-button href="#" variant="collapsible" :class="collapseAlerts ? '' : ' collapsed'" :aria-expanded="collapseAlerts ? 'true' : 'false'" aria-controls="collapseAlerts" @click="collapseAlerts = !collapseAlerts">
											<span class="when-opened">
												<font-awesome-icon icon="chevron-down" />
											</span>
											<span class="when-closed">
												<font-awesome-icon icon="chevron-right" />
											</span>
										</b-button>
									</div>
								</div>
							</div>
							<b-collapse id="collapseAlerts" :visible="collapseAlerts" class="collapse--content">
								<b-col class="mb-3 mt-3">
									Be notified when closures have not been reported at the start or completion times.
								</b-col>
								<b-col class="mb-3">
								<user-notification-setting :setting="'lc-not-closed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								<user-notification-setting :setting="'lc-not-opened'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								<user-notification-setting :setting="'r-not-placed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								<user-notification-setting :setting="'r-not-removed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								</b-col>
							</b-collapse>
						</template>
					</div>
				</b-col>
			</b-row>

			<b-row>
				<b-col>
					<div :class="collapseReports ? 'text-primary collapsible' : 'text-primary collapsible collapsed'">
						<template>
							<div class="collapsible-heading p-0">
								<div class="d-flex flex-nowrap bottom-border">
									<div class="collapsible-heading__value" @click="collapseReports = !collapseReports">
										Reported Opening/Closing of Lanes and Turning Restrictions
									</div>
									<div class="collapsible-heading__toggle">
										<b-button href="#" variant="collapsible" :class="collapseReports ? '' : ' collapsed'" :aria-expanded="collapseReports ? 'true' : 'false'" aria-controls="collapseReports" @click="collapseReports = !collapseReports">
											<span class="when-opened">
												<font-awesome-icon icon="chevron-down" />
											</span>
											<span class="when-closed">
												<font-awesome-icon icon="chevron-right" />
											</span>
										</b-button>
									</div>
								</div>
							</div>
							<b-collapse id="collapseReports" :visible="collapseReports" class="collapse--content">
								<b-col class="mb-3 mt-3">
									Be notified when lanes are reported closed at the start and re-opened at completion.
								</b-col>
								<b-col class="mb-3">
								<user-notification-setting :setting="'lc-closed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								<user-notification-setting :setting="'lc-opened'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								<user-notification-setting :setting="'r-placed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								<user-notification-setting :setting="'r-removed'" :hideWeb="hideWeb" v-model="user.notificationSetting.value" v-on:notificationsetting:update="updateNotificationSetting"></user-notification-setting>
								</b-col>
							</b-collapse>
						</template>
					</div>
				</b-col>
			</b-row>

		<b-row class="notification-settings__playSoundToggle app-only">
		<b-col class="pt-1" md="auto">
		    <label for="toggleMyAlltoggleMyAllSound"><strong>Play a sound for all Push Notifications</strong></label>
		</b-col>
		<b-col md="auto">
		    <div class="on-off-switch-field">
		            <input id="toggleMyAlltoggleMyAllSound" class="on-off-switch" :checked="notifyAllSound"  value="1" type="checkbox" @change="toggleNotifyAllSound()">
		            <label for="toggleMyAlltoggleMyAllSound"></label>
		    </div>
		</b-col>
		</b-row>



<b-row>
	<b-col class="mt-3">
		<div v-if="errorMsg != null" class="invalid-feedback d-block mb-3">{{errorMsg}}</div>
    <p><strong>Please note that your account will need to be approved before you can log in.</strong></p>
		<b-button variant="primary" type="button" @click="onSubmit" :state="user.status"
				:invalid-feedback="user.invalidMessage" class="mr-3 mb-2"
>Submit Account for Approval<b-spinner small label="Please wait..." class="ml-2" v-if="saving"></b-spinner></b-button>

	<b-button variant="light" @click="goBack" class="mb-2">Back to Login</b-button>


	</b-col>
</b-row>

<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
	<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
	<ul>
		<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'reqfield'+requiredField">{{$t(requiredField)}}</li>
	</ul>
	<template slot="footer">
		<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
	</template>
</b-modal>

<!-- leaving page -->
<b-modal centered id="unsaved-changes-error-modal" title="Unsaved Changes" size="lg" v-model="showUnsavedChangesModal" @ok="modalOnCancel()">
	<p class="is-size-6">{{ $t('messages.unsavedChanges') }}</p>
	<template v-slot:modal-footer="{ ok }">
		<!-- <b-button variant="primary"  type="button" @click="modalOnSave">{{$t('labels.save')}} <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button> -->
		<b-button variant="danger" type="button" @click="modalOnLeave">{{$t('labels.leaveAnyway')}}</b-button>
		<b-button variant="secondary"  type="button" @click="modalOnCancel">{{$t('labels.stay')}}</b-button>
	</template>
</b-modal>

</b-form>
        </div>
    </div>
</template>

<script>
import RegisterUser from '../models/RegisterUser';
import CreateUserRequest from '../models/CreateUserRequest';
import BootstrapField from '../utility/BootstrapField';
import ErrorHandler from '../utility/ErrorHandler';
import PincodeInput from '../components/vue-pincode-input/Component';
import Format from '../utility/Format';
import User from '../models/User';
// import Autocomplete from '@trevoreyre/autocomplete-vue'
import { VueSelectGrouped } from '../components/vue-select-grouped';
import UserNotificationSetting from '../components/UserNotificationSetting.vue';

// import Spinner from "../components/Spinner.vue";
import BrandingHeading from '../components/BrandingHeading';


import Vue from 'vue'

  export default {
    docTitle: "Register - Lane Closures",
    props:['pin'],
    components: {
  	BrandingHeading,
      PincodeInput,
	// Autocomplete,
	VueSelectGrouped,
	// Spinner,
	UserNotificationSetting,
    },
    data(){
      return {
		User,
		Format,
    organizationPrefix:new BootstrapField({
          value: ""}),
    editedDomain:"INITIAL__DATA",
        username : "",
        email : "",
        password : "",
        password_confirmation : "",
        is_admin : null,
        inputCode:"",
        inputCodeStatus:null,
        inputCodeMessage:null,
        code:"",
        roleId:null,
		jwt:null,
		CreateUserRequest,
		editedUsername: '',
		user: null,
		RegisterUser,
		form: null,
		collapseLcrUpdateNotifications: false,
		collapseReports: false,
		collapseAlerts: false,
		collapseReminders: false,
		collapseViolations: false,
		collapseOrganizationRequests:false,
		collapseMyRequests:false,
		collapseLcrUpdateNotificationsAll: false,
		collapseReportsAll: false,
		collapseAlertsAll: false,
		collapseRemindersAll: false,
		collapseViolationsAll: false,
		collapseOrganizationRequestsAll:false,
		collapseMyRequestsAll:false,
		organizations: [],
		passwordFieldType:"password",
		errorMsg: null,
		showUnsavedChangesModal:false,
		lineIndexError:null,
		isButtonDisabled: false,
		saveState:null,
		modalRequiredFieldList: [],
		showInvalidCodeModal: false,
		showRequiredFieldModal: false,
		requesterProjectIdOptions: [],
		show: true,
		status:null,
		submissionStatus: null,
		showNewOrganizationModal: false,
		organizationInfo:null,
		submitted: false,
		submittedCode: false,
		resendToken:null,
		passwordStrength:0,
		confirmPasswordStrength:0,
		onSubmitPromiseDeferred: {
			resolve:null,
			reject:null
		},
		usernamePrefix:new BootstrapField({
					value: null, required:true,
					validator: function(value) {
						if (value == null || value == "null" || value == "") {
							return false;
						}
						return true;
					},
					invalidMessage: 'Please enter username',
				}),
		saving: false,
      }
    },
	computed: {
		hideWeb: function() {
			if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
				return false;
			}
			return true;
		},
		notifyAllSound() {
			if (this.user) {
				if (this.user.notificationSetting) {
					for (var x = 0; x < this.user.notificationSetting.value.length; x++) {
						if (this.user.notificationSetting.value[x]) {
							if (
								this.user.notificationSetting.value[x].notifySoundMyLcr == 0 ||
								this.user.notificationSetting.value[x].notifySoundAllLcr == 0) {
								return false;
							}
						}
					}
				}
			}
		    return true;
		},
		organizationSuffix: function() {
			if (this.user) {
				if (this.organizationInfo) {
					if (this.organizationInfo.domain) {
						return this.organizationInfo.domain;
					}
				}
			}
			return "";
		}
	},
	watch: {
		'user.organizationId.value':function() {
			this.calculateUserName();
		},
		'usernamePrefix.value':function() {
			this.calculateUserName();
		},
		'user.phone.value':function() {
		}
	},
    methods: {
    		    toggleNotifyAllSound() {
    		    	if (this.user) {
    		    		if (this.user.notificationSetting) {
    		    			var x = 0;
    		    			if(this.notifyAllSound) {
    			    			for (x = 0; x < this.user.notificationSetting.value.length; x++) {
    	  						this.user.notificationSetting.value[x].notifySoundMyLcr = 0;
    	  						this.user.notificationSetting.value[x].notifySoundAllLcr = 0;
    			    			}
    		    			} else {
    			    			for (x = 0; x < this.user.notificationSetting.value.length; x++) {
    	  						this.user.notificationSetting.value[x].notifySoundMyLcr = 1;
    	  						this.user.notificationSetting.value[x].notifySoundAllLcr = 1;
    			    			}
    			    		}
    		    		}
    		    	}
    		    },
    	onPhoneFocus:function() {
    		if (this.user.phone.value == null || this.user.phone.value == "") {
    			setTimeout(function(){
    			      document.getElementById('registerPhone').value = "1-";
    			      document.getElementById('registerPhone').selectionStart = document.getElementById('registerPhone').value.length;
    			      document.getElementById('registerPhone').selectionEnd = document.getElementById('registerPhone').value.length;
    			    },1);  // call the function after 50ms
    		}
    	},
    	onPhoneBlur:function() {
    		if (this.user.phone.value == "1-" || document.getElementById('registerPhone').value == "1-") {
    			this.user.phone.value = null;
    			setTimeout(function(){
    			    document.getElementById('registerPhone').value = null;
    			},1);  // call the function after 50ms
    		}
    	},
    	onAltPhoneFocus:function() {
    		if (this.user.altPhone.value == null || this.user.altPhone.value == "") {
    				// this.user.altPhone.value = "1-";
    			setTimeout(function(){
    			      document.getElementById('registerAltPhone').value = "1-";
    			      document.getElementById('registerAltPhone').selectionStart = document.getElementById('registerAltPhone').value.length;
    			      document.getElementById('registerAltPhone').selectionEnd = document.getElementById('registerAltPhone').value.length;
    			    },1);  // call the function after 50ms

    		}
    	},
    	onAltPhoneBlur:function() {
    		if (this.user.altPhone.value == "1-" || document.getElementById('registerAltPhone').value == "1-") {
    			this.user.altPhone.value = null;
    			setTimeout(function(){
    			    document.getElementById('registerAltPhone').value = null;
    			},1);  // call the function after 50ms
    		}
    	},

      handlePinCodeInput: function(val) {
        this.code = val;
      },

	handleLCKeypress: function(event) {
		if (event.key == " " || event.key == 'PageUp' || event.key == 'PageDown') {
			event.preventDefault();
		}
	},
	setUsernameValidateStyle() {
		document.getElementById('username-editable-content').classList.remove('is-invalid');
		document.getElementsByClassName('lc__username')[0].getElementsByClassName('invalid-feedback')[0].classList.remove('d-block');
		if(this.usernamePrefix.value == '') {
			document.getElementById('username-editable-content').classList.add('is-invalid');
		}
	},
	focusUsernameField(e) {
		document.getElementById('username-prefix').focus();
	},
	setFocusStyle() {
		requestAnimationFrame(() => document.execCommand('selectAll'));
		document.getElementById('username-editable-content').classList.add('focus');
	},
	setNewUsername(e) {
		this.editedUsername = e.target.innerText;
		if (e.target.innerText == "" && e.target.innerHTML != "")  {
			this.editedUsername = e.target.innerHTML;
		}
	},
	removeUsernameFocus() {
		// console.log('1', this.usernamePrefix.value);
			this.usernamePrefix.value = this.editedUsername.trim();
		// console.log('2', this.usernamePrefix.value);
		this.setUsernameValidateStyle();
		document.getElementById('username-editable-content').classList.remove('focus');
	},
  	switchPasswordVisibility() {
  	  this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
  	},

	// required fields notifying modal
	modalRequiredFieldClose(){
		this.showRequiredFieldModal = false;
	},
	updateNotificationSetting(data) {
		let i = 0;
		if (this.user) {
			if (this.user.notificationSetting) {

				for (i = 0; i < this.user.notificationSetting.value.length; i++) {
					if (this.user.notificationSetting.value[i].notificationTypeId == data.notificationTypeId) {

						if (data.notifyEmailAllLcr == true || data.notifyEmailAllLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyEmailAllLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyEmailAllLcr = 0;
						}
						if (data.notifyEmailMyLcr == true || data.notifyEmailMyLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyEmailMyLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyEmailMyLcr = 0;
						}


						if (data.notifyAppAllLcr == true || data.notifyAppAllLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyAppAllLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyAppAllLcr = 0;
						}
						if (data.notifyAppMyLcr == true || data.notifyAppMyLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyAppMyLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyAppMyLcr = 0;
						}

						if (data.notifySoundAllLcr == true || data.notifySoundAllLcr == 1 ) {
							this.user.notificationSetting.value[i].notifySoundAllLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifySoundAllLcr = 0;
						}
						if (data.notifySoundMyLcr == true || data.notifySoundMyLcr == 1 ) {
							this.user.notificationSetting.value[i].notifySoundMyLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifySoundMyLcr = 0;
						}

						if (data.notifyBrowserAllLcr == true || data.notifyBrowserAllLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyBrowserAllLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyBrowserAllLcr = 0;
						}
						if (data.notifyBrowserMyLcr == true || data.notifyBrowserMyLcr == 1 ) {
							this.user.notificationSetting.value[i].notifyBrowserMyLcr = 1;
						} else {
							this.user.notificationSetting.value[i].notifyBrowserMyLcr = 0;
						}

					}
				}
			}
		}
	},

	calculateUserName() {
		if (this.user) {
			if (this.usernamePrefix.value) {
				this.user.username.value = this.usernamePrefix.value + this.organizationInfo.domain;
			} else {
				this.user.username.value = null;
			}
		} else {
			this.user.username.value = null;
		}
		// TODO: confirm that user name is not taken.
	},
	modalInvalidCodeClose() {
		this.showInvalidCodeModal = false;
	},
	setOrganization(val) {
		let x = 0;
		if (typeof val == "object") {
			for (x = 0; x < this.organizations.length; x++) {
				if (val) {
					if (val.id == 	this.organizations[x].id) {

						this.organizationInfo = this.organizations[x];
						localStorage.setItem('editingParentOrganizationId', this.organizations[x].id);
					}
				}
			}
		} else {
			for (x = 0; x < this.organizations.length; x++) {
				if (val == 	this.organizations[x].id) {

					this.organizationInfo = this.organizations[x];
					localStorage.setItem('editingParentOrganizationId', this.organizations[x].id);
				}
			}
		}
	},
	getOrgName() {
		if (this.user.organizationId.value.parentId == null) {
			return "<strong>"+this.user.organizationId.value.name+"</strong>";
		} else {
			return this.getFlatTree(this.user.organizationId.value);
		}
	},
	getFlatTree(option) {
		if (option.namePath) {
			return Format.pipesToFlatTree(option.namePath);
		} else {
			return option.name;
		}
	},
	showErrors(errors){
		this.submissionStatus = 'submission-error';
		this.modalRequiredFieldList = [];
		for(let field in errors) {
			this.modalRequiredFieldList.push(errors[field]);
		}
		this.showRequiredFieldModal = true;
	},

	getLevelClassName(level) {
		return "level-"+level;
	},

		goBack() {
			this.$router.push('/')
		},
		onSubmitCode(evt) {
			evt.preventDefault()
			this.onSubmitCodePromise();
		},

		onSubmitCodePromise() {
			if (!this.validateCode()) {
				return false;
			}
			let that = this;
			return new Promise(function(resolve,reject){
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;
				that.SubmitAccessCode(that.code);
			});
		},



		onSubmit(evt) {
			evt.preventDefault()
			if (!this.validateFields()) {
				return false;
			}

			let that = this;
			return new Promise(function(resolve,reject){
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;
				that.PostCreateUserRequest(that.user);
			});

		},
		onReset(evt) {
			evt.preventDefault()
			this.show = false
			this.$nextTick(() => {
			this.show = true
			})
		},

		PostCreateUserRequestOld(t) {
			if (t instanceof RegisterUser) {
				this.saving = true;
				Vue.prototype.$http.post(this.$store.state.apiUrl + '/new-user-request/?jwt='+this.jwt, t.getRawValue())
					.then(resp => {
						// Handle Success
						this.saveState = 'success';
						this.submissionStatus = 'submission-success';
						this.saving = false;
						this.SaveNewSuccess();
						this.onSubmitPromiseDeferred.resolve();
					})
					.catch(error => {
						this.saving = false;

						if (error) {
							this.saveState = 'fail';
							if (!ErrorHandler.HasLoginErrorCode(error)) {
								// this.user.SetErrors(error.response.data);
								this.showErrors(error.response.data.fields);
							} else {
								ErrorHandler.RedirectToLogin();
							}
							this.onSubmitPromiseDeferred.reject();
						}
					}).finally(() => {
					this.isButtonDisabled = false;
				});
			}
		},




		resendConfirmationEmail() {
			this.saving = true;
			if (this.resendToken != null) {
			this.isButtonDisabled = true;
				Vue.prototype.$http({
					method: 'get',
					url: `${this.$store.state.apiUrl}/resend-user-request-confirm-email/?jwt=${this.resendToken}&r=${Math.round(Math.random() * Math.pow(10, 6))}`
				}).then(response => {
					// Handle Success
				}).catch(error => {
					this.saveState = 'fail';
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.user.SetErrors(error.response.data);
						this.showErrors(error.response.data.fields);
					} else {
						// ErrorHandler.RedirectToLogin();
					}
					this.onSubmitPromiseDeferred.reject();
				}).finally(() => {
					this.isButtonDisabled = false;
				this.saving = false;

				});
			}
		},


		SubmitAccessCode(code) {
			// check
			this.saving = true;

			if (code != null) {
				this.isButtonDisabled = true;
				let go = true;
				if (go) {
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/validate-new-account-pin/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: {code:code}
				}).then(response => {
					// Handle Success
            this.user = new RegisterUser({
              isAway:0,isActive:1,isEmailConfirmed:1,isApproved:1,roles:[{id:'agency_user'}],
            notifyEmailAllLcr: 0,
            notifyEmailMyLcr: 1,
            notifyAppAllLcr: 0,
            notifyAppMyLcr: 1,
            notifyBrowserAllLcr: 0,
            notifyBrowserMyLcr: 1,
            notifySoundAllLcr: 0,
            notifySoundMyLcr: 0,
            useDefaultNotificationSettings:true,
            });
            // firstName:"LC",
            // lastName:"Eight",
            // email:"lc8@patterninteractive.com",
            // phone:"1-204-555-5555",
            // altPhone:"1-333-333-3333",
            // password:"Hello",
            // this.usernamePrefix.value = "lc8";
						if (  response.data.organizations ) {
							response.data.organizations.forEach( item => {
								if (item.isActive == 0) item.name += " (inactive)";
								this.organizations.push(item);
								if (item.id == response.data.organizationId) {
									this.user.organizationId.value = item;
								}
							})
						}
					if (this.user.organizationId.value == null) {
						this.user.organizationId.value = this.organizations[0];
					}
					this.jwt = response.data.jwt;
					this.roleId = response.data.roleId;

					this.saveState = 'success';
					this.saving = false;
					this.submittedCode = true;
					this.SubmitAccessCodeSuccess();
					this.onSubmitPromiseDeferred.resolve();
				}).catch(error => {
					this.saveState = 'fail';
					if (error.response) {
						if (error.response.status == 400) {
							this.inputCodeStatus = false;
							if (error.response.data.error.message) {
								this.inputCodeMessage = error.response.data.error.message;
							} else {
								this.inputCodeMessage = "Invalid Access Code";
							}
						}
					}
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.user.SetErrors(error.response.data);
						// this.showErrors(error.response.data.fields);
					}
					this.saving = false;
					this.onSubmitPromiseDeferred.reject();
				}).finally(() => {
					this.isButtonDisabled = false;
				});
				}
			}
		},
		SubmitAccessCodeSuccess() {
			// this.user.SetErrors({});
		},

		PostCreateUserRequest(t) {
			// Saves a new user request
			this.saving = true;

			if (t instanceof RegisterUser) {
				this.isButtonDisabled = true;
				let go = true;
				if (go) {
					let data = t.getRawValue();
					if (this.jwt != null) {
						data.jwt = this.jwt;
					}

				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/new-user-request/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: data
				}).then(response => {
					// Handle Success
					this.resendToken = response.data.resendToken;
					this.saveState = 'success';
					this.saving = false;
					this.submitted = true;
					this.submissionStatus = 'submission-success';
					this.SaveNewSuccess();
					this.onSubmitPromiseDeferred.resolve();
				}).catch(error => {
					this.saveState = 'fail';
					// console.log(error);
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.user.SetErrors(error.response.data);
						// console.log(error);
						this.showErrors(error.response.data.fields);
					} else {
						// ErrorHandler.RedirectToLogin();
					}
					this.saving = false;
					this.onSubmitPromiseDeferred.reject();
				}).finally(() => {
					this.isButtonDisabled = false;
				});
				}
			}
		},
		SaveNewSuccess() {
			// this.user.SetErrors({});
		},

		validateCode() {
			if (this.code == null) {
				this.inputCodeStatus = false;
				this.inputCodeMessage = "Please enter your access code.";
				return false;
			}
			if (this.code.length < 6) {
				this.inputCodeStatus = false;
				this.inputCodeMessage = "Please enter your access code.";
				return false;
			}
			this.inputCodeStatus = null;
			return true;
		},
		validateFields() {

			let flag = this.user.validate();
			if (this.usernamePrefix.validate() === false) {
				flag = false;
			}
			if (flag === false) {
				this.errorMsg = "There is a problem with a field above."
			} else {
				this.errorMsg = null;
			}
			return flag;
		},

		updatePasswordStrength(password) {
			let has_number    = /\d/.test(password);
			let has_lowercase = /[a-z]/.test(password);
			let has_uppercase = /[A-Z]/.test(password);
			let has_special   = /[!@#\$%\^\&*\)\(+=._-]/.test(password);  // eslint-disable-line
			let strength = 0;
			if (has_number) {
				strength++;
			}
			if (has_lowercase) {
				strength++;
			}
			if (has_uppercase) {
				strength++;
			}
			if (has_special) {
				strength++;
			}
			if (password.length < 8) {
				strength = 0;
			}
			this.passwordStrength = strength;
		},

		modalOnCancel() {
			this.showUnsavedChangesModal = false;
			if (this.$store.getters.logoutRequested) {
				this.$store.commit('logoutRequested', false);
		}
		},

		loadParentOrganization() {
			let parentId = localStorage.getItem('editingParentOrganizationId');

			if (parentId) {
				for (var i in this.organizations) {
					if (this.organizations[i].id == parentId) {
						this.user.organizationId.value = this.organizations[i];
						break;
					}
				}
			}

		},

          register: function () {
            let data = {
              name: this.name,
              email: this.email,
              password: this.password,
              is_admin: this.is_admin
            }
            this.$store.dispatch('register', data)
           .then(() => this.$router.push('/'))
					 .catch(error => console.log(error)) // eslint-disable-line
          }
	}, // end of methods();
	mounted() {
		if (this.$route.params.pin != null) {
			this.inputCode = this.$route.params.pin;
		}
	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			Vue.prototype.$bus.$emit("map:clear", 1);
			Vue.prototype.$bus.$emit("map:toggle", 0);
	});
	},
	beforeRouteLeave(to, from, next) {
		if (this.loaded && this.user.hasChanges()) {
			if (this.overrideUnsavedChanges) {
				next(true);
			} else {
				this.showUnsavedChangesModal = true;
				this.modalOnSave = (function() {
					this.onSubmit().then(() => {
						next(true);
					}).catch(() => {
						next(false);
					});
				}).bind(this);

				this.modalOnLeave = (function() {
					this.showUnsavedChangesModal = false;
					next(true);
				}).bind(this);

				next(false);
			}
		}
		else {
			next(true);
		}
	},
  }
</script>